import { toRefs, ref, watch } from 'vue';

export default {
  name: 'fullModal',
  props: {
    // モーダルのコンテンツ表示部のID。teleportの遷移先指定で使用する想定。
    contentId: { type: String, required: true },
    // モーダルを表示するか否か。
    showModal: { type: Boolean, default: false, required: false },
  },

  setup(props) {
    // 親コンポーネントからのデータや関数
    const { contentId, showModal } = toRefs(props);
    // リアクティブな変数
    const show = ref(false); // propsをb-modalに指定するとpropsの上書き警告が発生するため、コンポーネント変数をかませる

    watch(showModal, (newVal) => {
      show.value = newVal;
    });

    return {
      contentId,
      show
    };
  }
};